
<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <!-- Cookie Banner -->
    <div v-if="showCookieBanner" class="cookies-eu-banner">
      {{t("By clicking 'Accept', you agree to the storing of cookies on your device to enhance site usability")}}
      <button class="decline-btn skew" @click="declineCookies">
        {{t("Decline")}}
      </button>
      <button class="accept-btn skew" @click="acceptCookies">
        {{t("Accept")}}
      </button>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { Shop } from '@element-plus/icons-vue'
import { MenuIcon, XIcon } from '@heroicons/vue/outline'
import { useState } from 'modules/auth/store/state'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'CookiesBanner',
  components: {
    Shop,
    XIcon,
    MenuIcon,
  },
  setup() {
    const authState = useState()
    const { t } = useI18n()
    const showCookieBanner = ref(true)
    
    const getLayoutFooterBg = () => {
      return `bg-footer-theme`;
    }

    const acceptCookies = () => {
      authState.setCookie(true);
      showCookieBanner.value = false;
    }

    const declineCookies = () => {
      authState.setCookie(false);
      showCookieBanner.value = false;
    }

    const checkCookieConsent = () => {
      if (authState.cookie !== null) {
        showCookieBanner.value = false;
      }
    }

    checkCookieConsent();

    return {
      t,
      showCookieBanner,
      getLayoutFooterBg,
      acceptCookies,
      declineCookies,
      checkCookieConsent,
    }
  },
})
</script>


<style scoped>
.cookies-eu-banner {
  background: #444;
  color: #fff;
  padding: 6px;
  font-size: 16px;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
}

.cookies-eu-banner .accept-btn {
  background: green;
  color: #fff;
  border: 1px solid #000;
  cursor: pointer;
  padding: 4px 7px;
  margin: 2px 2px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 20px;
  transition: background 0.07s, color 0.07s, border-color 0.07s;
}

.cookies-eu-banner .decline-btn {
  background: #d9534f;
  color: #fff;
  border: 1px solid #000;
  cursor: pointer;
  padding: 4px 7px;
  margin: 2px 2px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 20px;
  transition: background 0.07s, color 0.07s, border-color 0.07s;
}

.cookies-eu-banner button:hover {
  background: #fff;
  color: #222;
}

</style>